import { Period, Producer } from '../types/commission';

export const producer: Producer = {
  name: 'Marcus Ellery',
  branch: 'Charlotte, NC · Branch 208',
  nmls: 'NMLS #1184920',
  avatarInitials: 'ME',
};

export const periods: Period[] = [
  {
    id: '2026-08',
    label: 'August 2026',
    isCurrent: true,
    daysElapsed: 13,
    daysTotal: 31,
    scorecard: { points: 11240, goal: 10000 },
  },
  {
    id: '2026-07',
    label: 'July 2026',
    isCurrent: false,
    daysElapsed: 31,
    daysTotal: 31,
    scorecard: { points: 12860, goal: 10000 },
  },
  {
    id: '2026-06',
    label: 'June 2026',
    isCurrent: false,
    daysElapsed: 30,
    daysTotal: 30,
    scorecard: { points: 8410, goal: 10000 },
  },
  {
    id: '2026-05',
    label: 'May 2026',
    isCurrent: false,
    daysElapsed: 31,
    daysTotal: 31,
    scorecard: { points: 10300, goal: 10000 },
  },
];

export const borrowerFirstNames = [
  'Ana',
  'David',
  'Grace',
  'Tom',
  'Sofia',
  'Kim',
  'Luis',
  'Hannah',
  'Rohan',
  'Erin',
  'Priya',
  'Jared',
  'Monica',
  'Andre',
  'Lena',
  'Victor',
  'Nathan',
  'Sonia',
  'Dean',
  'Iris',
  'Camille',
  'Owen',
  'Talia',
  'Marcus',
  'Delia',
];

export const borrowerLastNames = [
  'Martinez',
  'Chen',
  'Okafor',
  'Whitfield',
  'Reyes',
  'Nguyen',
  'Delgado',
  'Brooks',
  'Patel',
  'Caldwell',
  'Raman',
  'Kowalski',
  'Sterling',
  'Boone',
  'Fontaine',
  'Alvarado',
  'Brill',
  'Vargas',
  'Whitmore',
  'Lindqvist',
  'Duarte',
  'Baptiste',
  'Nakamura',
  'Ferraro',
  'Ashby',
];

export const loanProducts = [
  'Conventional Purchase',
  'FHA Purchase',
  'VA Purchase',
  'Jumbo Purchase',
  'Refinance',
];
